import { useContext } from 'react'
import { CookieNoteContext } from '@contexts/CookieNoteContext'
import type { CookieNoteContextValue } from '@contexts/CookieNoteContext'

export const useCookieNote = (): CookieNoteContextValue => {
  const contextValue = useContext(CookieNoteContext)

  if (contextValue === null) {
    throw new Error('No "CookieNoteContextProvider" configured')
  }

  return contextValue
}
